import type { LicenseStatus } from '#layers/license/public';
import { QUERY_PARAMS } from '#layers/access/constants/auth';
import { LICENSE_LOCKED_ROUTE_NAME } from '#layers/access/constants/routes';

export interface LicenseLockedDecisionInput {
	isUnderTest: boolean;
	isGuestOrPublicRoute: boolean;
	isLockPage: boolean;
	loggedIn: boolean;
	licenseStatus: LicenseStatus | null;
	redirectPath: string;
}

export interface LicenseLockedRedirect {
	name: typeof LICENSE_LOCKED_ROUTE_NAME;
	query: Record<string, string>;
}

/**
 * Returns a redirect for a logged-in user on a non-exempt route of a `locked`
 * instance; `undefined` (pass) otherwise. `'grace'` is not a lockout.
 */
export function decideLicenseLocked(input: LicenseLockedDecisionInput): LicenseLockedRedirect | undefined {
	if (input.isUnderTest) return undefined;
	if (input.isGuestOrPublicRoute) return undefined;
	if (input.isLockPage) return undefined;
	if (!input.loggedIn) return undefined;
	if (input.licenseStatus !== 'locked') return undefined;

	return {
		name: LICENSE_LOCKED_ROUTE_NAME,
		query: { [QUERY_PARAMS.redirect]: input.redirectPath },
	};
}
